import { ChapterModel } from '../../models/chapter.model';
import { StoryChapterThumbnail } from '../../models/story-chapter-thumbnail.model';

export class StoryChaptersStateModel {
    loading: boolean;
    chapters: ChapterModel[];
    chaptersModified: { [id: string]: boolean };
    selectedChapter: string;
    isChapterAnimated: boolean;
    shadowChapter: ChapterModel;
    thumbnails: Map<string, StoryChapterThumbnail>;
}
